import { createSelector } from '@reduxjs/toolkit';

import type { CasinoConfigType } from '../../../api/fetchers/casinoConfig/types';
import type { Compliance } from '../../../api/fetchers/playerConfig/types';
import type { CoreRootState } from '../../CoreStore';

export const selectNetPositionEnabled = createSelector(
  [
    (state: CoreRootState): Compliance | null => state.config.compliance,
    (state: CoreRootState): CasinoConfigType | null => state.config.casinoConfig,
  ],
  (compliance, casinoConfig) => {
    const hideNetPositionInitial = casinoConfig?.forceHideNetPosition;
    const hideNetPosition = hideNetPositionInitial ?? false;

    return !!(compliance?.netPosition && !hideNetPosition);
  }
);
